<template>
  <div class="main">
    <div class="header">
      <div class="back" @click="goBack">
        <img :src="backImage" />
      </div>
      <user-icon></user-icon>
    </div>
    <div class="new" @click="newPost">+</div>
    <div class="body" :style="background">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import back from "../../assets/dkleech.png";
import image from "../../assets/leechbg.png";

import router from "../../router";
import { UserIcon } from "@/components";

export default {
  components: {
    UserIcon,
  },
  data() {
    return {
      backImage: back,
    };
  },
  methods: {
    goBack() {
      router.push("/igler");
    },
    newPost() {
      router.push("/igler/ny");
    },
  },
  computed: {
    background() {
      return {
        backgroundImage: 'url("' + image + '")',
        backgroundColor: "#ffdff2",
        backgroundSize: "100px",
        backgroundBlendMode: "lighten",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;

  .header {
    position: absolute;
    top: 0;
    left: 0;
    height: 60px;
    padding: 5px;
    box-sizing: border-box;
    width: 100%;
    z-index: 1000;
    background-color: #ffffff;
    box-shadow: 0 3px 5px #999999;
    display: flex;
    justify-content: space-between;

    .back {
      border-radius: 50%;
      width: 50px;
      height: 50px;
      box-sizing: border-box;
      padding: 5px;
      cursor: pointer;
      background-color: #444444;

      img {
        height: 40px;
        width: 40px;
      }
    }
  }

  .new {
    position: absolute;
    top: 80px;
    right: 20px;
    height: 60px;
    width: 60px;
    z-index: 1000;
    border-radius: 50%;
    background-color: #d05366;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 70px;
    box-shadow: 0 0 10px #999999;

    transition: box-shadow 0.2s;

    border: 4px solid white;

    &:hover {
      border: 4px solid white;
      box-shadow: 0 0 10px #333333;
    }
  }

  .body {
    width: 100%;
    height: calc(100% - 100px);
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 100px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}
</style>
